import React, { memo } from "react";
import Buttons from "components/Buttons";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Images } from "config/images";

const MenuInfo = ({ data }) => {
	const classes = useStyles();
	const history = useHistory();

	const isSpecialOffer = data?.isShow?.isSpecialOffer || false;
	const isOrderHistory = data?.isShow?.isOrderHistory || false;

	return (
		<Grid container classes={{ root: classes.root }}>
			<Grid item xs={12} style={{ marginBottom: 12 }}>
				<Buttons
					startIcon={
						<img
							src={Images.icSpecialOffers}
							alt={"icSpecialOffers"}
						/>
					}
					onClick={() => history.push("/games")}
					fontSize={13}
					colortext={"white"}
					backgroundcolor={`linear-gradient(93.3deg, #8d2c91 0%, #FA9825 100.98%)`}
					backgroundimage={`url(${Images.bgSpecialOffers})`}
				>
					Vui với game nhận thưởng lớn
				</Buttons>
			</Grid>
			{isSpecialOffer && (
				<Grid
					item
					xs={isOrderHistory ? 6 : 12}
					style={{ paddingRight: isOrderHistory ? 5 : 0 }}
				>
					<Buttons
						startIcon={
							<img
								src={Images.icSpecialOffers}
								alt={"icSpecialOffers"}
							/>
						}
						onClick={() => history.push("/special_offer")}
						fontSize={13}
						colortext={"white"}
						backgroundcolor={`linear-gradient(93.3deg, #FDD869 0%, #FA9825 100.98%)`}
						backgroundimage={`url(${Images.bgSpecialOffers})`}
					>
						Chương trình ưu đãi
					</Buttons>
				</Grid>
			)}
			{isOrderHistory && (
				<Grid
					item
					xs={isSpecialOffer ? 6 : 12}
					style={{ paddingLeft: isSpecialOffer ? 5 : 0 }}
				>
					<Buttons
						startIcon={
							<img
								src={Images.icHistoryOrder}
								alt={"icHistoryOrder"}
							/>
						}
						onClick={() => history.push("/order_history")}
						fontSize={13}
						colortext={"white"}
						backgroundcolor={`linear-gradient(93.3deg, #97B8FB 0%, #667AF4 100.98%)`}
						backgroundimage={`url(${Images.bgSpecialOffers})`}
					>
						Lịch sử mua hàng
					</Buttons>
				</Grid>
			)}
		</Grid>
	);
};

export default memo(MenuInfo);
